import { HomeTab } from "./recruiter/HomeTab";
import { ContactTab } from "./recruiter/ContactTab";

export const RecruitmentTabs = {
  Home: HomeTab,
  Contact: ContactTab,
};
